var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9805 0H6.01913C2.97588 0 0.5 2.476 0.5 5.51924V14.4806C0.5 17.524 2.97588 19.9999 6.01913 19.9999H14.9805C18.024 19.9999 20.4999 17.5239 20.4999 14.4806V5.51924C20.5 2.476 18.024 0 14.9805 0ZM18.7255 14.4806C18.7255 16.5455 17.0455 18.2254 14.9806 18.2254H6.01913C3.95433 18.2255 2.27449 16.5455 2.27449 14.4806V5.51924C2.27449 3.45445 3.95433 1.77449 6.01913 1.77449H14.9805C17.0454 1.77449 18.7254 3.45445 18.7254 5.51924V14.4806H18.7255Z",
    fill: "#C691FB",
    stroke: "black",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 4.84668C7.65824 4.84668 5.34644 7.15848 5.34644 10.0001C5.34644 12.8417 7.65824 15.1534 10.4999 15.1534C13.3416 15.1534 15.6534 12.8417 15.6534 10.0001C15.6534 7.15848 13.3416 4.84668 10.4999 4.84668ZM10.4999 13.3788C8.63681 13.3788 7.12092 11.8631 7.12092 10C7.12092 8.13681 8.63669 6.62105 10.4999 6.62105C12.3631 6.62105 13.8789 8.13681 13.8789 10C13.8789 11.8631 12.363 13.3788 10.4999 13.3788Z",
    fill: "#C691FB",
    stroke: "black",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8697 3.34277C15.5278 3.34277 15.1919 3.48118 14.9505 3.7237C14.7078 3.96503 14.5684 4.301 14.5684 4.64406C14.5684 4.98607 14.708 5.32192 14.9505 5.56443C15.1918 5.80576 15.5278 5.94535 15.8697 5.94535C16.2127 5.94535 16.5475 5.80576 16.79 5.56443C17.0325 5.32192 17.1709 4.98595 17.1709 4.64406C17.1709 4.301 17.0325 3.96503 16.79 3.7237C16.5487 3.48118 16.2127 3.34277 15.8697 3.34277Z",
    fill: "#C691FB",
    stroke: "black",
    strokeWidth: 0.909091
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b29d35505d4662ea5084dc9a59f7b4db.svg";
export { ForwardRef as ReactComponent };